/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * @emails react-core
 */

import SurveyBanner from './SurveyBanner';

export default SurveyBanner;
